import moment, { type Moment } from "moment";
import i18next from "i18next";

export interface IDay {
  Date: string;
  Number: string;
  Weekday: number;
  LastDay: boolean;
}

export interface IMonth {
  Year: number;
  Month: number;
  Name: string;
  Days: IDay[];
}

export const isBefore = (date: Date, compareDate: Date) => {
  return date < compareDate;
};

export const validEndDate = (date: string, endDate: string) => {
  return date <= endDate;
};

export const datesBetween = (startDate: string, endDate: string) => {
  let dates = [];
  let currentDate = moment(startDate).utc();
  const tillDate = moment(endDate).utc();
  while (currentDate <= tillDate) {
    dates.push(getIsoString(currentDate));
    currentDate.add(1, "days");
  }
  return dates;
};

export const getMonths = (startDate: Moment, endDate: Moment) => {
  const months: any = [];
  for (var m = startDate; m.isSameOrBefore(endDate); m.add(0, "M")) {
    const month = {
      Year: m.year(),
      Number: m.month(),
      Days: getDays(m),
    };
    months.push(month);
  }
  return months;
};

export const getIsoString = (date: Moment) => {
  return date.format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
};

export const getDays = (start: Moment) => {
  const days: IDay[] = [];
  let end = start.clone();
  end = end.endOf("month").startOf("day");
  for (let d = start; d.isSameOrBefore(end); d.add(1, "d")) {
    const day: IDay = {
      Date: getIsoString(d),
      Number: d.format("DD"),
      Weekday: d.day(),
      LastDay: d.format() === end.format(),
    };
    days.push(day);
  }
  return days;
};

export const dateToMonthSmall = (date: string | null) => {
  if (date) {
    return moment(date).utc().format("MMM D dddd");
  }
  return "";
};

/**
 * Format date time to weekday, day of the month, short month day, year with localization from the config/translationEn.ts file
 * @param date
 * @returns
 */
export const formatDateLong = (date: string | null, addYear: boolean = true) => {
  const weekdays = i18next.t("weekDays", { returnObjects: true }) as [];
  const months = i18next.t("shortMonths", { returnObjects: true }) as [];
  const parts: string[] = [];
  if (date) {
    const weekDay = weekdays[moment(date).utc().format("d") as any] as string;
    const month = months[Number(moment(date).utc().format("M")) - 1] as string;
    parts.push(weekDay);
    parts.push(moment(date).utc().format("D"));
    parts.push(month);
    if (addYear) {
      parts.push(moment(date).utc().format("yyyy"));
    }
  }
  return parts.join(" ");
};
